export const syncingCopy = {
  heading: 'Updating property data…',
  message:
    'The app is currently downloading data critical for its operation. Please do not interrupt the download.',
};

export const offlineCopy = {
  heading: 'Update needed',
  message:
    'The app needs to fetch data critical for its operation from the server. Please connect to the internet to retry.',
};
